import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TooltipTapDirective} from '~/app/shared/directives/tooltip-tap.directive';

@NgModule({
    declarations: [
        TooltipTapDirective,
    ],
    imports: [
        CommonModule,
        MatTooltipModule,
    ],
    exports: [
        TooltipTapDirective,
    ],
})
export class DirectiveModule {
}
